import React from "react";
import { useTranslation } from "react-i18next";

// Modale de confirmation stylée (remplace window.confirm, hors-charte).
// Contrôlée par un objet `state` : { message, confirmLabel, cancelLabel?, danger?, onConfirm } ou null.
export default function ConfirmModal({ state, onClose }) {
  const { t } = useTranslation();
  if (!state) return null;
  const { message, confirmLabel, cancelLabel, danger } = state;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 10060, padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff", borderRadius: 14, padding: 22, maxWidth: 360,
          width: "100%", textAlign: "center", boxShadow: "0 16px 48px rgba(0,0,0,0.28)",
        }}
      >
        <p style={{ margin: "0 0 18px", color: "#334", fontSize: 15, lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <button
            onClick={onClose}
            style={{ background: "#eef2f4", border: "none", borderRadius: 8, padding: "8px 16px", fontWeight: 600, cursor: "pointer", color: "#556" }}
          >
            {cancelLabel || t("common.cancel")}
          </button>
          <button
            onClick={() => { state.onConfirm?.(); onClose(); }}
            style={{ background: danger ? "#e05252" : "var(--primary-blue)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontWeight: 700, cursor: "pointer" }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
